import { twMerge } from 'tailwind-merge';
import { SponserList, WebSection } from '@wbk/contentful/api';
import { Paper, Typography } from '@wbk/ui';
import { ContentfulMedia } from '@wbk/contentful';

type Props = {
  section: WebSection;
  className?: string;
};

const SponsorsSection = ({ section, className = '' }: Props) => {
  const sponsorList = section.contentCollection as unknown as SponserList;

  if (!sponsorList?.items?.length) return null;

  return (
    <Paper className={twMerge('space-y-6 rounded-[14px] py-6', className)}>
      <div className='space-y-6 text-center'>
        {sponsorList.items.map((sponsorGroup) => {
          if (!sponsorGroup?.sponsorsCollection?.items?.length) return null;

          return (
            <div key={sponsorGroup.id} className='mx-auto max-w-4xl space-y-2'>
              {sponsorGroup.title && (
                <Typography
                  as='p'
                  variant='heading-M'
                  className='text-center font-semibold'
                  style={{ color: sponsorGroup.titleColor || '' }}
                >
                  {sponsorGroup.title}
                </Typography>
              )}

              <div className='flex flex-wrap items-center justify-center gap-6'>
                {sponsorGroup.sponsorsCollection.items.map((sponsor) => {
                  if (!sponsor) return null;

                  const SponsorImage = (
                    <ContentfulMedia
                      key={sponsor.id}
                      media={sponsor.logo}
                      className='h-full max-h-[80px] w-auto object-contain'
                    />
                  );

                  if (sponsor.link) {
                    return (
                      <a
                        href={sponsor.link}
                        target='_blank'
                        rel='noreferrer'
                        key={sponsor.id}
                        className='transition-opacity hover:opacity-80'
                      >
                        {SponsorImage}
                      </a>
                    );
                  }

                  return SponsorImage;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </Paper>
  );
};

export default SponsorsSection;
